import React, { Component } from 'react';
import { withStyles } from '@material-ui/core';

const styles = {
    localRequirementsExpandedContainer: {
        overflowX: 'scroll',
    },
};
class LocalRequirementsExpanded extends Component {
    render() {
        const { classes } = this.props;
        return (
            <div className={classes.localRequirementsExpandedContainer}>
                <p>The following ports must not be used by any other local processes:</p>
                <table>
                    <thead>
                        <td>
                            <strong>Protocol</strong>
                        </td>
                        <td>
                            <strong>Direction</strong>
                        </td>
                        <td>
                            <strong>Port Range</strong>
                        </td>
                        <td>
                            <strong>Change Type</strong>
                        </td>
                        <td>
                            <strong>Product</strong>
                        </td>
                        <td>
                            <strong>Description</strong>
                        </td>
                    </thead>

                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>8080</td>
                        <td>Local Server</td>
                        <td>Media Shuttle and Jet</td>
                        <td>Used to register SDCX Server</td>
                    </tr>
                    <tr>
                        <td>HTTPS</td>
                        <td>Local</td>
                        <td>8443</td>
                        <td>Local Server</td>
                        <td>Media Shuttle</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>8888</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>UDP</td>
                        <td>Local</td>
                        <td>50222-50421</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>50443</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>50080</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>50081</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>51221-51320</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to SDCX Server</td>
                    </tr>
                    <tr>
                        <td>TCP</td>
                        <td>Local</td>
                        <td>61001-61003</td>
                        <td>Local Server</td>
                        <td>Jet</td>
                        <td>Local connection to Signiant Communication Service</td>
                    </tr>
                </table>
            </div>
        );
    }
}

export default withStyles(styles)(LocalRequirementsExpanded);
